import { useState, useEffect } from 'react';

export function useDevToolsStatus() {
    const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);

    useEffect(() => {
        const detectDevTools = () => {
            const threshold = 160; // Customize based on browser behavior
            const widthThreshold = window.outerWidth - window.innerWidth > threshold;
            const heightThreshold = window.outerHeight - window.innerHeight > threshold;

            setIsDevToolsOpen(widthThreshold || heightThreshold);
        };

        detectDevTools(); // Initial detection

        const handleResize = () => {
            detectDevTools(); // Recheck on window resize
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return isDevToolsOpen;
}
